module.exports = __webpack_public_path__ + "img/data_moun_js.77e1c9d4.png";